export const any = (source, predicate) => {
    if (predicate) {
        return any2(source, predicate);
    }
    else {
        return any1(source);
    }
};
const any1 = async (source) => {
    for await (const _ of source) {
        return true;
    }
    return false;
};
const any2 = async (source, predicate) => {
    for await (const item of source) {
        if (predicate(item) === true) {
            return true;
        }
    }
    return false;
};
